<template>
  <div>
    <div class="details-operation-list">
      <div class="details-operation-item" @click="toggleFirst">
        <img :src="detailsInfo.like ? require('@/assets/images/f5.png') : require('@/assets/images/f1.png')" />
        <span>{{ detailsInfo.likeCount }}</span>
      </div>
      <div class="details-operation-item" @click="toggleThird">
        <img :src="detailsInfo.collect ? require('@/assets/images/f6.png') : require('@/assets/images/f3.png')" />
        <span>{{ detailsInfo.collectCount }}</span>
      </div>
      <div class="details-operation-item" @click="toggleShare">
        <img src="@/assets/images/f4.png" />
        <span>{{ detailsInfo.shareCount }}</span>
      </div>
      <div class="details-operation-item" @click="showComment">
        <img src="@/assets/images/f2.png" />
        <span>{{ detailsInfo.commentCount }}</span>
      </div>
    </div>
    <div class="forum-comment-list">
      <div class="forum-comment-title">全部评论</div>
      <div class="forum-comment-content">
        <template v-if="commentList.length > 0">
          <div class="forum-comment-item" v-for="(item, index) in commentList" :key="index">
            <div class="forum-comment-header">
              <img v-if="item.avatar && item.avatar.url != undefined" :src="item.avatar.url" alt="">
              <img v-else src="@/assets/images/defaultHead.png" alt="">
              <span>{{ item.nickname }}</span>
            </div>
            <div class="forum-comment-text">
              {{ item.content }}
            </div>
            <div class="forum-comment-bottom">
              {{ item.createTimeFormat }}
            </div>
          </div>
        </template>
        <empty class="empty-margin" v-if="commentList.length <= 0"></empty>
        <div class="pagination-box">
          <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
            @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
        </div>
      </div>
    </div>
    <commentInput :showCommentPop.sync="showCommentPop" :id="id"></commentInput>
  </div>
</template>

<script>
import empty from "@/components/empty/index";
import commentInput from "@/components/base/commentInput"
import { getInformationComment, informationPraise, informationCollect, informationShare } from '@/api/home'
export default {
  components: { empty, commentInput },
  data() {
    return {
      page: {
        number: 1,
        limit: 10,
        total: 0,
      },
      commentList: [],
      showCommentPop: false,
    }
  },
  props: {
    detailsInfo: {
      type: Object,
      default: {},
    },
    id: {
      type: String,
      default: "",
    },
  },
  methods: {
    // 分页查询资讯评论
    getInformationCommentFun() {
      getInformationComment({
        informationId: this.id,
        number: this.page.number,
        limit: this.page.limit,
        checkStatus: 'SUCCESS',
      }).then(res => {
        if (res.code == "A00000") {
          this.commentList = res.data
          this.page.total = res.totalCount
        }
      })
    },
    toggleFirst() {
      informationPraise({
        informationId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          this.$emit("getPageDetails")
        }
      })
    },
    toggleThird() {
      informationCollect({
        informationId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          this.$emit("getPageDetails")
        }
      })
    },
    toggleShare() {
      informationShare({
        informationId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          const url = `${window.location.href.split("#")[0]}#/NewsDetailsThree/${this.id}` // 获取当前页面的URL
          navigator.clipboard.writeText(url).then(() => {
            // 复制成功后的回调
            this.$message.success("已复制链接!")
            this.$emit("getPageDetails")
          }).catch(err => {
            // 复制失败的处理
            console.error('复制失败:', err);
          });
        }
      })
    },
    showComment() {
      this.showCommentPop = true
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getInformationCommentFun()
    },
    currentChange(value) {
      this.page.number = value
      this.getInformationCommentFun()
    },
    prevClick(value) {
      this.page.number = value
      this.getInformationCommentFun()
    },
    nextClick(value) {
      this.page.number = value
      this.getInformationCommentFun()
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getInformationCommentFun()
    })
  }
}
</script>

<style lang="less" scoped>
.details-operation-list {
  background-color: #FFFFFF;
  border-radius: 0 0 6px 6px;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  gap: 24px;

  .details-operation-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    border: 1px solid #999999;
    border-radius: 4px;

    img {
      width: 14px;
      height: 14px;
      vertical-align: bottom;
      margin-right: 6px;
    }

    span {
      font-size: 14px;
      color: #666666;
      font-weight: 600;
    }
  }
}

.forum-comment-list {
  background: #fff;
  border-radius: 6px;
  padding: 6px 16px 16px;
  margin-top: 30px;

  .forum-comment-title {
    border-bottom: 1px solid #E6E6E6;
    line-height: 50px;
    color: #222222;
    font-size: 22px;
    font-weight: 600;
    position: relative;
    text-align: left;
    margin-bottom: 32px;
  }

  .forum-comment-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 112px;
    background-color: #BD181E;
  }

  .forum-comment-content {
    text-align: left;

    .forum-comment-item {
      padding: 20px 18px;
      border-bottom: 0.5px solid #E5E6EB;

      .forum-comment-header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        span {
          font-size: 14px;
          color: #222222;
          font-weight: 600;
        }

        img {
          width: 26px;
          height: 26px;
          margin-right: 6px;
          vertical-align: bottom;
          border-radius: 50%;
        }
      }

      .forum-comment-text {
        margin-bottom: 12px;
        color: #222222;
        font-size: 15px;
        font-weight: 600;
      }

      .forum-comment-bottom {
        color: #999999;
        font-weight: 600;
        font-size: 12px;
      }
    }
  }
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}

.pagination-box {
  width: 100%;
  text-align: center;
}

.empty-margin {
  margin: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/informationBottom.vue